export const environment = {
  production: false,
  apiUrl: "https://api-release.ek-mediencenter.de",
  matomo: {
    enabled: false,
    serverUrl: 'https://piwiktest.ek-webserver.de/',
    siteId: 15
  },
  sso: {
    enabled: true,
    tenant: "ekretailssoa",
    clientId: "6ddfe3b0-7818-4a03-957b-c94a879fbdc2",
    redirectUri: "https://release.ek-mediencenter.de/sso",
  },
  launchpad: {
    enabled: false,
    url: "",
  },
};
